import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SalaryType } from '../../models/employee/employee.model';

export interface SalaryRevealResponse {
  unlockToken: string;
  expiresOn: string;
  basicSalary: number | null;
  salaryType: SalaryType | null;
  salaryVisible: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SalaryUnlockService {
  private composeToken: string | null = null;
  private readonly employeeTokens = new Map<string, string>();

  constructor(private http: HttpClient) {}

  reveal(password: string, employeeGuid?: string | null): Observable<SalaryRevealResponse> {
    return this.http
      .post<SalaryRevealResponse>(
        `${environment.employee.root}/salary-reveal`,
        { password, employeeGuid: employeeGuid || null },
        { withCredentials: true },
      )
      .pipe(
        tap((response) => {
          if (employeeGuid) {
            this.employeeTokens.set(employeeGuid, response.unlockToken);
          } else {
            this.composeToken = response.unlockToken;
          }
        }),
      );
  }

  tokenForEmployee(employeeGuid: string): string | null {
    return this.employeeTokens.get(employeeGuid) ?? null;
  }

  composeUnlockToken(): string | null {
    return this.composeToken;
  }

  clearCompose(): void {
    this.composeToken = null;
  }
}
